module.exports = __webpack_public_path__ + "favicon/safari-pinned-tab.svg";